import React from "react";
import IconTransaction from  "../../../common/assets/icons/transaction.png";
import { Button } from "react-bootstrap";
import { capitalizeFirst, kopecks2rubStr, replaceStr } from "../../../common/functions";
import { ITransactionsByMonth } from "../../payments/logics/types";
import IconInfoGray from  "../../../common/assets/icons/infoGray.png";
import "../styles/AccountTransactionsItemTitle.css";
import { $SiteColors } from "../../../common/config/company-atts";

interface IAccountTransactionsItemTitle {
  transactionByMonth: ITransactionsByMonth,
  showTableCliked: () => void;
  hideTable: boolean, 
  hideInfo: boolean,
  i: number,
}

const titleOptions = {
  year: 'numeric',
  month: 'long'
};

export const AccountTransactionsItemTitle = ({transactionByMonth, showTableCliked, hideTable, hideInfo, i}: IAccountTransactionsItemTitle) => {
  const wordStr = (yyyymm: string) => {
    if(yyyymm == '') return ''
    let dt = new Date(replaceStr(yyyymm, '-', 4))
    return capitalizeFirst(dt.toLocaleString('default', { month: 'long' })) + " " + dt.getFullYear()  //yyyymm == '' ? "" : capitalizeFirst((new Date(replaceStr(yyyymm, '-', 4) )).toLocaleString("ru", titleOptions))
  }

  return (
    <div className="a_atit_li">
      <div className="a_atit_main_con">
        <img src={IconTransaction} className="a_atit_img"></img>
        <span className="a_atit_period_name">{wordStr(transactionByMonth.yyyymm)}</span>
        <div className="a_atit_charges_con">
          <span className="a_atit_charges_amount">{kopecks2rubStr(transactionByMonth.monthPayments)}</span>
          <div className="tooltip1" style={{pointerEvents: i == 0 ? "all" : "none"}}>
            <img src={IconInfoGray} className="a_atit_amount_img" style={{visibility: hideInfo ? "hidden" : "visible"}}/>
            <span className="tooltip1text">Итого начислено.</span>
          </div>
        </div>
        <div className="a_atit_payments_con" >
          <span className="a_atit_payments_amount" style={{color:$SiteColors.getState().chargeTextColor}}>{kopecks2rubStr(transactionByMonth.monthCharges)}</span>
          <div className="tooltip1" style={{pointerEvents: i == 0 ? "all" : "none"}}>
            <img src={IconInfoGray} className="a_atit_amount_img" style={{visibility: hideInfo ? "hidden" : "visible"}}/>
            <span className="tooltip1text">Итого оплачено.</span>
          </div>
        </div>
        <div className="a_atit_show_table_con">
          <Button onClick={showTableCliked} variant="link" size="sm" className="a_atit_show_table_btn">
            <span>{(hideTable ? "Подробнее" : "Скрыть")}</span>
          </Button>
        </div>
      </div>
    </div>
  );
};